import React, { useState } from 'react';
import '../styles/components/FechaSelector.css';
const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

const FechaSelector = ({ onDateChange }) => {
  const [mes, setMes] = useState('');
  const [anual, setAnual] = useState('');

  const handleMesChange = (e) => {
    const selectedMes = e.target.value;
    setMes(selectedMes);
    onDateChange(selectedMes, anual);
  };

  const handleAnualChange = (e) => {
    const selectedAnual = e.target.value;
    setAnual(selectedAnual);
    onDateChange(mes, selectedAnual);
  };

  

  return (
    <div className="fecha-selector">

      <select value={mes} onChange={handleMesChange}>
        <option value="">Selecciona un mes</option>
        {MESES.map((nombreMes, i) => (
          <option key={i + 1} value={i + 1}>{nombreMes}</option>
        ))}
      </select>

      
      <select value={anual} onChange={handleAnualChange}>
        <option value="">Selecciona un año</option>
        {[...Array(3)].map((_, i) => (
          <option key={i} value={2024 + i}>{2024 + i}</option>
        ))}
      </select>
    </div>
  );
};

export default FechaSelector;
